import React from 'react';

export default (props) => {
  return (
    <div className="form-msg">
      {props.formMsg}
    </div>
  )
}
